import Vue from "vue";
Vue.prototype.$deneme = "Test Prop";